// extracted by mini-css-extract-plugin
export default {"header":"receipt-header_header__p3DAP","disabledInput":"receipt-header_disabledInput__4lcKt","buttons":"receipt-header_buttons__gVnMp"};